import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";
import ArticleCard from "@/components/public/ArticleCard";

export default function KoleksiyonlarListPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/collections"); setItems(data || []); })(); }, []);

  return (
    <>
      <SEO title="Capella Collections — Tematik Kapadokya Koleksiyonları"
           description="Romantik, ailelere özel, fotoğraf tutkunları için, ilk kez gelenler için Kapadokya'nın editör seçkisi tematik koleksiyonları." />
      <section className="pt-40 pb-16 max-w-7xl mx-auto px-6 md:px-12" data-testid="koleksiyonlar-header">
        <div className="text-[10px] tracking-[0.28em] uppercase text-cc-sepia mb-5">Capella Collections</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-[1.02] mb-8">
          Tematik <span className="italic">koleksiyonlar.</span>
        </h1>
        <p className="max-w-2xl text-cc-muted text-lg leading-[1.85]">
          Editörlerimizin Kapadokya'yı belirli bir hisle ya da bir hikâye için süzdüğü içerik seçkileri.
        </p>
      </section>

      <section className="pb-32 max-w-7xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="koleksiyonlar-grid">
        {items.map((c, i) => (
          <Link key={c.id} to={`/koleksiyonlar/${c.slug}`} data-testid={`koleksiyon-${c.slug}`}
                className="cc-card group block cc-reveal" style={{ animationDelay: `${0.05 * i}s` }}>
            <div className="cc-card-img-wrap aspect-[4/5] mb-5 overflow-hidden">
              <img src={c.cover_image_url} alt={c.title} className="cc-card-img w-full h-full object-cover" />
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-cc-sepia mb-2">Koleksiyon · {c.article_ids?.length || 0} yazı</div>
            <h3 className="cc-card-title font-serif text-2xl md:text-[1.65rem] leading-snug text-cc-text mb-3">{c.title}</h3>
            <p className="text-sm text-cc-muted leading-relaxed line-clamp-3">{c.description}</p>
          </Link>
        ))}
        {items.length === 0 && <p className="text-cc-muted col-span-full">Henüz koleksiyon yok.</p>}
      </section>
    </>
  );
}

export function KoleksiyonDetailPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true); setErr(false);
      try { const { data } = await api.get(`/collections/${slug}`); setDoc(data); }
      catch { setErr(true); } finally { setLoading(false); }
    })();
  }, [slug]);

  if (loading) return <div className="pt-40 max-w-3xl mx-auto px-6"><p className="text-cc-muted">Yükleniyor…</p></div>;
  if (err || !doc) return <div className="pt-40 text-center"><h1 className="font-serif text-4xl">Koleksiyon bulunamadı</h1></div>;

  return (
    <>
      <SEO title={doc.title} description={doc.description}
           ogImage={doc.cover_image_url}
           breadcrumbs={[
             { label: "Ana Sayfa", url: "/" },
             { label: "Koleksiyonlar", url: "/koleksiyonlar" },
             { label: doc.title, url: window.location.pathname },
           ]} />
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden grain">
        <img src={doc.cover_image_url} alt={doc.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-cc-dark/55" />
        <div className="relative h-full max-w-5xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-16 text-cc-bg">
          <div className="text-[10px] tracking-[0.28em] uppercase text-cc-bg/80 mb-5">Koleksiyon</div>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.02] mb-6">{doc.title}</h1>
          <p className="text-cc-bg/85 text-base md:text-lg max-w-2xl leading-relaxed">{doc.description}</p>
        </div>
      </section>

      <section className="py-20 md:py-28 max-w-7xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
        {(doc.articles || []).map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
        {(!doc.articles || doc.articles.length === 0) && <p className="text-cc-muted col-span-full">Bu koleksiyonda henüz yazı yok.</p>}
      </section>
    </>
  );
}
